import {IsBoolean, IsNotEmpty, IsNumber, IsOptional, IsString} from "class-validator";
import { Identifiable } from "./identifiable";

export interface AvgPriceResult {
  typeId: number;
  typeName: string;
  countryAvg: number | null;
  cityAvgs?: Array<{
    cityId: number;
    regionId: number;
    countryId: number;
    avgPrice: number | null;
  }>;
  regionAvgs?: Array<{
    cityIds:  number[];
    regionId: number;
    countryId: number;
    avgPrice: number | null;
  }>;
    countryAvgs?: Array<{
    cityIds:  number[];
    regionIds: number[];
    countryId: number;
    avgPrice: number | null;
  }>;
}

export class CreateMediaTypeDto {
  @IsString()
  @IsNotEmpty()
  name: string;
}

export class UpdateMediaTypeBaseDataDto extends CreateMediaTypeDto implements Identifiable{
  @IsNumber()
  id: number;

  @IsOptional()
  @IsBoolean()
  isOrdReport?: boolean;
}

export class MediaTypeBaseDataDto extends UpdateMediaTypeBaseDataDto{
  @IsOptional()
  @IsNumber()
  publishingDataId: number | null;

  @IsOptional()
  avgPriceTypeMedia: AvgPriceResult;
}
